/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */

/*       eslint-disable eqeqeq                                       */
/*       eslint-disable no-nested-ternary                            */

/* ***************************************************************** */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  TextField,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import { createClassFromLiteSpec } from 'react-vega-lite';
import ApexChart from '../../components/Chart';
import SnackMessage from '../../components/SnackMessage';
import { useForceUpdate } from '../../hooks';
import DraggableModal from '../../components/DraggableModal';
import { setCornRXAdjustments } from '../../lib/api';
import { selectors, actions } from '../../store/dux/cornrx-dux';
import { getLayerLegend } from '../../services/chart-colors';
import { usePermission } from '../../hooks/use-permission';
import { calculateStats } from '../../lib/stats';

const cornRateLimits = {
  20: { min: 25000, max: 42000 },
  30: { min: 25000, max: 38000 },
};

const mapSpec30 = {
  height: 200,
  width: 200,
  padding: 5,
  mark: {
    type: 'geoshape',
  },
  projection: {
    type: 'mercator',
  },
  encoding: {
    tooltip: { field: 'TGT_RATE', type: 'quantitative' },
    color: {
      type: 'quantitative',
      field: 'properties.TGT_RATE',
      title: 'Target Rate',
      scale: {
        domain: [],
        range: [],
        type: 'linear',
      },
    },
  },
};

export default function CornRXAdjust(props) {
  const { selectedField } = props;
  const canAdjust = usePermission('RUN_RX');
  const dispatch = useDispatch();
  const prescriptions = useSelector(selectors.prescriptions);
  const isLoading = !Object.keys(prescriptions).length;
  const planterSpacing = useSelector(selectors.planterSpacing);
  const [fullAdjust30, setFullFieldAdjustment] = React.useState(0);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const forceUpdate = useForceUpdate();
  const cornRXColorRamp = getLayerLegend('cornrx') || {};

  function handleFullFieldChange(event) {
    setFullFieldAdjustment(event.target.value);

    if (!Number.isNaN(Number(event.target.value))) {
      handleGroupAdjustment(event, prescriptions[`CornRX${planterSpacing}`]);
    }
  }

  function handleGroupAdjustment(event, oneOrMany) {
    const { min: minRate, max: maxRate } = cornRateLimits[planterSpacing];
    const cloned = structuredClone(prescriptions);
    const groups = cloned[`CornRX${planterSpacing}`];
    const inputValue = event.target.value.replace(/[^0-9-]/g, '');
    const nValue = Number(inputValue);
    const adjustments = [oneOrMany].flat();

    groups.forEach((group) => {
      const rxvalue = adjustments.find((a) => a.BASERATE === group.BASERATE);
      if (!rxvalue) return;

      if (Number.isNaN(nValue) || !inputValue?.length) {
        group.RXADJUSTMENT = inputValue;
        return;
      }

      group.RXADJUSTMENT = nValue;
      const nRateValue =
        group.BASERATE +
        group.RXADJUSTMENT -
        ((group.BASERATE + group.RXADJUSTMENT) % 500);
      const nRate = nValue % 500 >= 250 ? nRateValue + 500 : nRateValue;

      group.TGT_RATE =
        nRate < minRate ? minRate : nRate > maxRate ? maxRate : nRate;

      group.RXADJUSTMENT =
        group.TGT_RATE == minRate || group.TGT_RATE == maxRate
          ? group.TGT_RATE - group.BASERATE
          : nValue;
    });

    const { min, max, avg } = calculateStats(
      groups.map((g) => ({ rate: g.TGT_RATE, acres: g.ACRES })),
    );

    selectedField.Min = min;
    selectedField.Max = max;
    selectedField.Avg =
      avg % 500 >= 250 ? avg - (avg % 500) + 500 : avg - (avg % 500);

    dispatch(actions.updateCornRXData(cloned));
    forceUpdate();
  }

  const handleSave = () => {
    const yldData = structuredClone(prescriptions)[`CornRX${planterSpacing}`];
    const mped = yldData.map((x) => ({
      RATE: x.BASERATE,
      RXADJUSTMENT: x.RXADJUSTMENT,
      AAMANAGEDID: x.AAMANAGEDID,
    }));

    setCornRXAdjustments(planterSpacing, mped);
    setSnackOpen(true);
    props.refreshData();
  };

  const handleRevert = () => {
    handleFullFieldChange({ target: { value: '0' } });
  };

  const distinct = (value, index, self) => self.indexOf(value) === index;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen(false);
  };

  const handleDGClose = (event) => {
    event.preventDefault();
    props.formopen(false);
  };

  const handleExited = () => {
    setSnackOpen(false);
  };

  let rx30Rend = { values: [] };
  let adjRend = { values: [] };

  const rx20Vis =
    planterSpacing != null && planterSpacing == '20' ? 'cornRX20' : null;

  const mp30 = Object.values(cornRXColorRamp)
    .map((colorMap) => ({ domain: colorMap.label, range: colorMap.color }))
    .filter((mx) => !Number.isNaN(Number(mx.domain)));

  mapSpec30.encoding.color.scale.domain = mp30
    .filter((fx) => fx.domain != '<Null>')
    .map((x) => Number(x.domain));
  mapSpec30.encoding.color.scale.range = mp30
    .filter((fx) => fx.domain != '<Null>')
    .map((x) => x.range);

  let rxmap = {
    values: { type: 'FeatureCollection', features: [] },
    format: { type: 'json', property: 'features' },
  };

  const chrtData = {
    stats: {
      min: selectedField.Min,
      max: selectedField.Max,
      avg: selectedField.Avg,
    },
    chart: {
      values: [],
    },
  };

  if (prescriptions && prescriptions.CornRX30) {
    let yldData = prescriptions.CornRX30;
    if (rx20Vis != null) {
      yldData = prescriptions.CornRX20;
    }
    const yldGeo = yldData.map((x) => ({
      id: x.TGT_RATE,
      type: 'Feature',
      geometry: JSON.parse(x.shape),
      properties: {
        OBJECTID: x.TGT_RATE,
        TGT_RATE: x.TGT_RATE,
        color: '#FFFFFF',
      },
    }));

    yldGeo.forEach((y) => {
      const itms = mp30.filter((rx) => rx.value == y.TGT_RATE);
      if (itms.length > 0) {
        y.color = itms[0].range;
      }
    });

    const dup = [];
    if (dup.length === 0) {
      rx30Rend = {
        values: yldData.map((x) => ({
          BASERATE: x.BASERATE,
          RXADJUSTMENT: x.RXADJUSTMENT,
          TGT_RATE: x.TGT_RATE,
          BINCOUNT: x.BINCOUNT,
          ACRES: x.ACRES,
          color: '#FFFFF',
        })),
      };
      adjRend = {
        values: yldData.map((x) => ({
          BASERATE: x.BASERATE,
          RXADJUSTMENT: x.RXADJUSTMENT,
          TGT_RATE: x.TGT_RATE,
          BINCOUNT: x.BINCOUNT,
          ACRES: x.ACRES,
          color: '#FFFFF',
        })),
      };
    } else {
      adjRend = {
        values: yldData.map((x) => ({
          BASERATE: x.BASERATE,
          value: x.TGT_RATE,
          label: x.ACRES,
          RXADJUSTMENT: x.RXADJUSTMENT,
          TGT_RATE: x.TGT_RATE,
          BINCOUNT: x.BINCOUNT,
          ACRES: x.ACRES,
          color: '#FFFFF',
        })),
      };
      const dist = yldData.map((x) => x.TGT_RATE).filter(distinct);
      dist.forEach((x) => {
        const vl = yldData.filter((y) => y.TGT_RATE == x)[0];
        vl.Color = '#FFFFF';
        rx30Rend.values.push(vl);
      });

      dup.forEach((d) => {
        const vl = yldData.filter((y) => d == y.TGT_RATE);
        let inVal = {};
        for (let i = 0; i < vl.length; i += 1) {
          if (i == 0) {
            const js = JSON.stringify(vl[i]);
            inVal = JSON.parse(js);
          } else {
            inVal.BINCOUNT += vl[i].BINCOUNT;
          }
        }
        rx30Rend.values.push(inVal);
      });
    }

    rx30Rend.values.forEach((y) => {
      const rates = Object.keys(cornRXColorRamp).filter(
        (rx) => rx == y.TGT_RATE,
      );
      if (rates.length > 0) {
        y.color = cornRXColorRamp[rates[0]].color;
      }
    });
    rxmap = {
      values: { type: 'FeatureCollection', features: yldGeo },
      format: { property: 'features' },
    };

    chrtData.colors = [...new Set(rx30Rend.values.map(({ color }) => color))];

    chrtData.chart.values = rx30Rend.values
      .map((x) => ({ label: x.TGT_RATE, value: x.ACRES }))
      .sort((a, b) => a.label - b.label);
  }

  const MapChart30 = createClassFromLiteSpec(mapSpec30);

  adjRend.values = adjRend.values.sort((a, b) => a.BASERATE - b.BASERATE);
  const itmsPerRow = Math.ceil(adjRend.values.length / 3);

  const clmnA = adjRend.values.slice(0, itmsPerRow);
  const clmnB = adjRend.values.slice(itmsPerRow, itmsPerRow * 2);
  const clmnC = adjRend.values.slice(itmsPerRow * 2);

  const handleFocus = (event) => event.target.select();

  return (
    <DraggableModal
      isLoading={isLoading}
      handleClose={() => props.formopen(false)}
      title={`${
        selectedField ? selectedField.fieldName : ''
      } CornRX Adjustment`}
    >
      <div style={{ width: '820px' }}>
        {selectedField && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <h3>Field Name: {selectedField.fieldName}</h3>
            <h3>Row Spacing: {planterSpacing}</h3>
            <h3>Min: {selectedField.Min}</h3>
            <h3>Max: {selectedField.Max}</h3>
            <h3>Avg: {selectedField.Avg}</h3>
          </div>
        )}
        <Typography gutterBottom component="div">
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <Paper style={{ marginLeft: '10px' }}>
              <Box sx={{ '& summary': { display: 'none !important' } }}>
                <ApexChart
                  xLabel="Seeds per Acre"
                  yLabel="Acres"
                  stats={chrtData}
                  chartWidth="500px"
                  mapComponent={rxmap ? <MapChart30 data={rxmap} /> : null}
                />
              </Box>
            </Paper>
          </Box>

          {canAdjust ? (
            <div>
              <div>
                <TextField
                  variant="standard"
                  label="Full Field Adjustment"
                  id="outlined-number"
                  value={fullAdjust30}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  onChange={handleFullFieldChange}
                  onFocus={handleFocus}
                  data-testid="field-adjustment"
                />
              </div>

              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Paper style={{ width: '220px' }}>
                  <List>
                    {clmnA.map((rxvalue, idx) => (
                      <ListItem key={rxvalue.BASERATE}>
                        <ListItemText
                          id={rxvalue.BASERATE}
                          primary={`Input ${rxvalue.BASERATE}`}
                          data-testid={`baserate-value-${idx}`}
                        />
                        <ListItemSecondaryAction
                          style={{
                            width: '54px',
                            right: '100px',
                            paddingBottom: '5px',
                          }}
                        >
                          <TextField
                            variant="standard"
                            id={`clmna_outlined-number_${idx}`}
                            key={rxvalue.BASERATE}
                            value={rxvalue.RXADJUSTMENT}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="normal"
                            onChange={(e) => handleGroupAdjustment(e, rxvalue)}
                            onFocus={handleFocus}
                            data-testid="adjustment-value"
                          />
                        </ListItemSecondaryAction>
                        <ListItemText
                          style={{ marginLeft: '55px' }}
                          primary={`Adjusted ${rxvalue.TGT_RATE}`}
                          data-testid="adjusted-value"
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>

                <Paper style={{ width: '220px' }}>
                  <List>
                    {clmnB.map((rxvalue, idx) => (
                      <ListItem key={rxvalue.BASERATE}>
                        <ListItemText
                          id={rxvalue.BASERATE}
                          primary={`Input ${rxvalue.BASERATE}`}
                        />
                        <ListItemSecondaryAction
                          style={{
                            width: '54px',
                            right: '100px',
                            paddingBottom: '5px',
                          }}
                        >
                          <TextField
                            variant="standard"
                            id={`clmnb_outlined-number_${idx}`}
                            key={rxvalue.BASERATE}
                            value={rxvalue.RXADJUSTMENT}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="normal"
                            onChange={(e) => handleGroupAdjustment(e, rxvalue)}
                            onFocus={handleFocus}
                            data-testid="adjustment-value"
                          />
                        </ListItemSecondaryAction>
                        <ListItemText
                          style={{ marginLeft: '55px' }}
                          primary={`Adjusted ${rxvalue.TGT_RATE}`}
                          data-testid="adjusted-value"
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>

                <Paper style={{ width: '220px' }}>
                  <List>
                    {clmnC.map((rxvalue, idx) => (
                      <ListItem key={rxvalue.BASERATE}>
                        <ListItemText
                          id={rxvalue.BASERATE}
                          primary={`Input ${rxvalue.BASERATE}`}
                        />
                        <ListItemSecondaryAction
                          style={{
                            width: '54px',
                            right: '100px',
                            paddingBottom: '5px',
                          }}
                        >
                          <TextField
                            variant="standard"
                            id={`clmnc_outlined-number_${idx}`}
                            key={rxvalue.BASERATE}
                            value={rxvalue.RXADJUSTMENT}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="normal"
                            onChange={(e) => handleGroupAdjustment(e, rxvalue)}
                            onFocus={handleFocus}
                            data-testid="adjustment-value"
                          />
                        </ListItemSecondaryAction>
                        <ListItemText
                          style={{ marginLeft: '55px' }}
                          primary={`Adjusted ${rxvalue.TGT_RATE}`}
                          data-testid="adjusted-value"
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>

                <Box
                  style={{ display: 'flex', flexWrap: 'wrap', width: '130px' }}
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  <List>
                    <ListItem>
                      <Button
                        onClick={() => handleRevert()}
                        variant="contained"
                        data-testid="revert-btn"
                        color="inherit"
                      >
                        Revert
                      </Button>
                    </ListItem>
                    <ListItem>
                      <Button
                        onClick={() => handleSave()}
                        variant="contained"
                        data-testid="save-btn"
                        color="inherit"
                      >
                        Save
                      </Button>
                    </ListItem>
                    <ListItem>
                      <Button
                        color="inherit"
                        variant="contained"
                        onClick={handleDGClose}
                      >
                        Close
                      </Button>
                    </ListItem>
                  </List>
                </Box>
              </div>
            </div>
          ) : null}
        </Typography>

        <SnackMessage
          open={snackOpen}
          handleClose={handleClose}
          handleExited={handleExited}
          message={'Save Complete'}
        />
      </div>
    </DraggableModal>
  );
}
